import { createFileRoute } from "@tanstack/react-router";

import { PublicationsList } from "./publications";

export const Route = createFileRoute("/_authenticated/studio/drafts")({
  head: () => ({
    meta: [
      { title: "Drafts — Creator Studio — Quibblies" },
      {
        name: "description",
        content:
          "Your private Quibblies drafts and work in progress. Drafts are never publicly visible until you submit them and they are approved.",
      },
      { property: "og:title", content: "Drafts — Quibblies Creator Studio" },
      { property: "og:description", content: "Private drafts and work in progress." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => (
    <div className="space-y-4">
      <p className="rounded-2xl border border-border/60 bg-background/60 p-4 text-sm text-muted-foreground">
        Drafts are private to you. Nobody else — including other members — can read them.
      </p>
      <PublicationsList only={["draft", "changes_requested"]} />
    </div>
  ),
});
